// import {workersInfo,workersApply} from './request';
import userHeader from '@/components/userHeader.vue';
export default {
  components: {
    userHeader
  },
  data() {
    return {
      infoObj: {},
      dataFrom: {}
    };
  },
  computed: {
    dataRule() {
      return {
        resignType: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('离职类型')
        }],
        resignAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('生效日期')
        }],
        resignReason: [{
          required: true,
          message: this.$t('请选择') + this.$t('离职原因'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('下级归属至')
        }],
        type2: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('续期分配方式')
        }]
      };
    }
  },
  created() {
    // workersInfo({companyWorkerId:this.$route.params.id}).then(res=>{
    //   this.infoObj=res;
    //   if(res.resignReason){
    //     this.dataFrom={
    //       resignType:res.resignType,
    //       resignReason:res.resignReason,
    //       resignAt:res.resignAt
    //     };
    //   }
    // });
  },
  methods: {
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          // let obj=this.dataFrom;
          // obj.customerId=this.infoObj.customerId;
          // obj.companyWorkerId=this.$route.params.id;
          // workersApply(obj).then(res=>{
          this.$message.success(this.$t('操作成功'));
          this.$router.go(-1);
          // });
        }
      });
    }
  }
};